import React, { useEffect } from 'react'
import { UserRole } from '@modmd/data'
import { Tabber } from 'components/Tabber'
import Card from 'components/Card'
import { QuestionnaireHistory } from 'sharedComponents/QuestionnaireHistory'
import { VaccineCard } from 'sharedComponents/VaccineRecord'
import useTabber from '../../internal-portal/hooks/useTabber'
import { useLocation } from 'react-router'

export interface Params {
  userId: string
  handleEditVaccineRecord?: () => void
  isSuperAdmin: boolean
  isAdmin?: boolean
  isNurseOrResults: boolean
}

enum EventTabberType {
  QuestionnaireHistory = 'QuestionnaireHistory',
  VaccineRecord = 'VaccineRecord',
}

interface LocationState {
  state?: {
    vaccine?: string
  }
}

export const EventClearenceUser = ({
  userId,
  handleEditVaccineRecord,
  isSuperAdmin,
  isAdmin,
  isNurseOrResults,
}: Params) => {
  const location: LocationState = useLocation()

  const { subTab, setSubTab } = useTabber()

  useEffect(() => {
    if (location.state?.vaccine) {
      setSubTab(EventTabberType.VaccineRecord)
    }
  }, [location.state])

  return (
    <Card borderRadius="0">
      <Tabber
        activeTabName={subTab}
        onChange={({ activeTabName }) => {
          setSubTab(activeTabName)
        }}
      >
        <Tabber.Item
          tabName={EventTabberType.QuestionnaireHistory}
          permissions={[
            UserRole.SUPER_ADMIN as UserRole,
            UserRole.ADMIN as UserRole,
            UserRole.RESULTS as UserRole,
            UserRole.NURSE as UserRole,
          ]}
          component={<QuestionnaireHistory userId={userId} />}
        >
          Questionnaire History
        </Tabber.Item>
        <Tabber.Item
          tabName={EventTabberType.VaccineRecord}
          permissions={[
            UserRole.SUPER_ADMIN as UserRole,
            UserRole.ADMIN as UserRole,
            UserRole.RESULTS as UserRole,
            UserRole.NURSE as UserRole,
          ]}
          component={
            <VaccineCard
              handleEditVaccineRecord={handleEditVaccineRecord}
              isPhotoEnabled
              userId={userId}
              isEditable={isSuperAdmin || isAdmin || isNurseOrResults}
            />
          }
        >
          Vaccine Record
        </Tabber.Item>
      </Tabber>
    </Card>
  )
}
